/**
 * ## Component manager component
 *
 * @module src/components/layout
 */

"use strict";

/**
 * dropdown display.
 */
const create = (options, data, callback) => {
  // build drop down.
  let drophtml = "";
  let dropcount = 0;
  let scroll = 0;
  let c = 0;
  data.forEach((row) => {
    if (
      options.highlight === row.value ||
      options.highlight === row.description
    ) {
      scroll = c * 45;
      drophtml += `<div class="dropdownitem theme_bg_carbon" id="dd${++dropcount}" \
                data-value="${row.value}" data-description="${
        row.description
      }">\
                <i class="fa fa-check"></i> ${row.description}</div>`;
    } else {
      drophtml += `<div class="dropdownitem" id="dd${++dropcount}" data-value="${
        row.value
      }" \
                data-description="${row.description}">${row.description}</div>`;
    }
    ++c;
  });
  $(`#${options.target_id}`).html(drophtml);
  TweenMax.to(`#${options.target_id}`, 0, {
    scrollTo: scroll,
  });
  $(".dropdownitem").off();
  $(".dropdownitem").fastClick((e) => {
    e.stopPropagation();
    const returned = {
      value: $(`#${e.target.id}`).data("value"),
      description: $(`#${e.target.id}`).data("description"),
    };
    callback(null, returned);
    destroy();
  });
};

const destroy = () => {
  $("#component_catch").css("display", "none");
};

module.exports = {
  create,
  destroy,
};



/** WEBPACK FOOTER **
 ** ./src/components/dropdown/index.js
 **/